// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"d52c3749","512":"86c8f384","1861":"8312710f","4251":"86c8f384","4751":"86c8f384","9548":"d52c3749"}[chunkId] + ".chunk.css";
};